<template>
  <b-card>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.date"
            type="date"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-else-if="filter2 === '2'">
          <b-form-input
            v-model="form.outlet_name"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
        <b-input-group v-else-if="filter2 === '3'">
          <b-form-input
            v-model="form.main_outlet_name"
            type="search"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <!-- TABLE :filter="filter"-->
    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(date)="data">
        {{ moment(data.value).format("DD/MM/YYYY") }}
      </template>

      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickEdit(data.item.id)"
            v-if="data.item.status_id === 4"
            >EDIT</b-button
          >
          <b-button
            variant="primary"
            size="sm"
            @click="onClickView(data.item.id)"
            v-else
            >VIEW</b-button
          >
        </span>
      </template>
    </b-table>

    <b-pagination
      v-if="!isLoading"
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination>

    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickCreate"
          >CREATE</b-button
        >
      </b-col>
    </b-row>

    <b-modal id="choose-category" title="Choose product category">
      <b-row>
        <b-col md="12">
          <b-form-group>
            <label :for="`input-size`"
              >Product Category <span class="danger-new"> *</span></label
            >
            <b-form-select
              v-model="pro_cat"
              :options="select.pro_cat"
              class="input-new"
              required
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer="{ close }">
        <b-button variant="primary" size="sm" @click="close()">
          Close
        </b-button>
        <b-button variant="primary" size="sm" @click="nextStockout()">
          Create
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      moment: moment,
      items: [],
      pro_cat: "1",
      form: {
        date: null,
        outlet_name: null,
        main_outlet_name: null
      },
      select: {
        pro_cat: [
          { text: "UHT", value: "1" },
          { text: "Pasteurized", value: "2" }
        ],
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Date", value: "1" },
          { text: "Outlet Name", value: "2" },
          { text: "Outlet Category", value: "3" }
        ]
      },
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      },
      indexsearch: 1,
      filter2: null,
      filterOn: [],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",

      // Loader
      isLoading: false
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  props: {
    fields: {
      type: Array,
      required: true
    },

    filter: {
      type: String,
      default: null
    },
    page: {
      type: String
    },
    date: {
      type: String
    },
    main_outlet_name: {
      type: String
    },
    outlet_name: {
      type: String
    }
  },
  created() {
    if (this.filter) {
      this.filter2 = this.filter !== "null" ? this.filter : null;
      this.pagination.current = this.page !== "null" ? this.page : null;
      this.indexsearch = this.page !== "null" ? this.page : null;
      this.form.main_outlet_name =
        this.main_outlet_name !== "null" ? this.main_outlet_name : null;
      this.form.date = this.date !== "null" ? this.date : null;
      this.form.outlet_name =
        this.outlet_name !== "null" ? this.outlet_name : null;

      if (this.filter !== "null") {
        this.onClickSearch();
      } else {
        this.pagination.current = this.page !== "null" ? this.page : null;
        this.getStockout();
      }
    } else {
      this.getStockout();
    }
  },
  methods: {
    onClickView(id) {
      this.$router.push({
        path: `stockout_user_view?id=${id}&cat=1&page=${this.pagination.current}&filter=${this.filter2}&date=${this.form.date}&main_outlet_name=${this.form.main_outlet_name}&outlet_name=${this.form.outlet_name}`
      });
    },
    onClickEdit(id) {
      this.$router.push({
        path: `stockout_user_create?stockid=${id}&type=update`
      });
    },

    onClickCreate() {
      this.$router.push({
        path: `stockout_user_create?cat=1&type=new`
      });
    },
    resetFilter() {
      this.form.date = null;
      this.form.outlet_name = null;
      this.form.main_outlet_name = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.date = null;
      this.form.outlet_name = null;
      this.form.main_outlet_name = null;
      this.pagination.current = 1;
      this.getStockout();
    },
    onClickSearch() {
      this.form.page = this.indexsearch;
      this.isLoading = true;
      if (this.filter2 === null) {
        this.getStockout();
      } else {
        this.$store.dispatch("searchStockout", this.form).then(res => {
          this.isLoading = false;
          this.items = [];
          let no = 0;
          if (res.data.response.code === 100) {
            res.data.data.data.forEach(element => {
              no = no + 1;
              let outletCat;
              if (element.outlet !== null) {
                outletCat = element.outlet.name;
              }

              this.items.push({
                no: no,
                name: element.outlethistory.outlet_name,
                category: outletCat,
                date: element.date,
                id: element.stock_id,
                type: element.type,
                status: element.status_details.desc,
                status_id: element.status
              });
            });
          }
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
      }
    },
    getStockout() {
      this.isLoading = true;

      this.$store
        .dispatch("getStockoutList", this.pagination.current)
        .then(res => {
          this.isLoading = false;
          this.items = [];

          if (res.data.response.code === 100) {
            res.data.data.data.forEach(element => {
              let outletCat;
              if (element.outlet !== null) {
                outletCat = element.outlet.name;
              }
              this.items.push({
                name: element.outlethistory.outlet_name,
                category: outletCat,
                date: element.date,
                id: element.stock_id,
                type: element.type,
                status: element.status_details.desc,
                status_id: element.status
              });
            });
          }
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
        });
    },
    onChangePage(index) {
      this.pagination.current = index;
      if (this.filter2 === null) {
        this.getStockout();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        this.onClickSearch();
      }
    },
    resetIndex() {
      this.indexsearch = 1;
    }
  }
};
</script>
<style lang="css" scoped></style>
